import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { FilterItemTypes } from "configs/types";
import { apiRoutes } from "configs/apiRoutes";
import instance from "api/apiClient";
import { useAppSelector } from "store/index";

import Filter from "components/global/Filter/Filter";

import gridIcon from "assets/icons/grid-icon.svg";

interface Props {
  searchValue: string;
  handleSearch: (e: string) => void;

  searchId: string;
  handleSearchId: (e: string) => void;

  searchPublicId: string;
  handleSearchPublicId: (e: string) => void;

  handleUpdateRisks: (e: { value: string | number; label: string }[]) => void;
  selectedRisks: { value: string | number; label: string }[];

  handleUpdateRoles: (e: { value: string | number; label: string }[]) => void;
  selectedRoles: { value: string | number; label: string }[];

  handleUpdateCurrencies: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedCurrencies: { value: string | number; label: string }[];

  handleUpdateGeos: (e: { value: string | number; label: string }[]) => void;
  selectedGeos: { value: string | number; label: string }[];

  handleUpdateCategories: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedCategories: { value: string | number; label: string }[];

  handleUpdateStatuses: (
    e: { value: string | number; label: string }[],
  ) => void;
  selectedStatuses: { value: string | number; label: string }[];

  firstDate: string;
  secondDate: string;
  handleApplyDate: (firstDate: string, secondDate?: string) => void;
  handleApply: () => void;
}
const PlayersFilter: React.FC<Props> = ({
  searchValue,
  handleSearch,

  searchId,
  handleSearchId,

  searchPublicId,
  handleSearchPublicId,

  handleUpdateRisks,
  selectedRisks,

  handleUpdateRoles,
  selectedRoles,

  handleUpdateCurrencies,
  selectedCurrencies,

  handleUpdateGeos,
  selectedGeos,

  handleUpdateCategories,
  selectedCategories,

  handleUpdateStatuses,
  selectedStatuses,

  firstDate,
  secondDate,
  handleApplyDate,
  handleApply,
}) => {
  const { t } = useTranslation();

  const geoList = useAppSelector((state) => state.settings.geoList);
  const currenciesList = useAppSelector((store) => store.settings.currencies);

  const [risks, setRisks] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [roles, setRoles] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [categories, setCategories] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [currencies, setCurrencies] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [statuses, setStatuses] = useState<
    { value: string | number; label: string }[]
  >([]);
  const [geos, setGeos] = useState<{ value: string | number; label: string }[]>(
    [],
  );

  const getStatuses = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.playerRiskList}?limit=500&offset=0`,
      );
      const array =
        result.data.items?.map((el: any) => ({
          value: el.id,
          label: el.title,
        })) ?? [];
      setRisks(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getCategories = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.playerCategoriesList}?limit=500&offset=0`,
      );
      const array =
        result.data.items?.map((el: any) => ({
          value: el.id,
          label: el.title,
        })) ?? [];
      setCategories(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getRoles = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.rolesList}?limit=500&offset=0`,
      );
      const array =
        result.data.items?.map((el: any) => ({
          value: el.id,
          label: el.title.replace(/^./, (letter: string) =>
            letter.toUpperCase(),
          ),
        })).sort((
          first: { value: string | number; label: string },
          second: { value: string | number; label: string },
        ) =>
          first.label.localeCompare(second.label, undefined, {
            sensitivity: "base",
          }),
        ) ?? [];
      setRoles(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  const getVerifications = async () => {
    try {
      const result = await instance.get(
        `${apiRoutes.playerVerificationStatusesList}?limit=500&offset=0`,
      );
      const array =
        result.data.items?.map((el: any) => ({
          value: el.id,
          label: el.title,
        })) ?? [];
      setStatuses(array);
    } catch (error) {
      console.log(error, "error");
    }
  };
  useEffect(() => {
    getVerifications();
    getCategories();
    getStatuses();
    getRoles();
  }, []);
  useEffect(() => {
    const result = geoList.map((el) => {
      return {
        value: el,
        label: el,
      };
    });
    setGeos(result);
  }, [geoList]);
  useEffect(() => {
    const result = currenciesList.map((el) => {
      return {
        value: el,
        label: el,
      };
    });
    setCurrencies(result);
  }, [currenciesList]);

  const handleApplyRisks = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateRisks(isDelete ? e : [...selectedRisks, ...e]);
  };
  const handleApplyRoles = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateRoles(isDelete ? e : [...selectedRoles, ...e]);
  };

  const handleApplyCurrencies = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateCurrencies(isDelete ? e : [...selectedCurrencies, ...e]);
  };

  const handleApplyGeos = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateGeos(isDelete ? e : [...selectedGeos, ...e]);
  };
  const handleApplyCategories = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateCategories(isDelete ? e : [...selectedCategories, ...e]);
  };

  const handleApplyStatuses = (
    e: { value: string | number; label: string }[],
    isDelete?: boolean,
  ) => {
    handleUpdateStatuses(isDelete ? e : [...selectedStatuses, ...e]);
  };

  const handleResetDate = (value: string) => {
    if (value === "from") handleApplyDate("", secondDate);
    if (value === "to") handleApplyDate(firstDate, "");
  };

  const handleClearFilters = () => {
    handleUpdateGeos([]);
    handleUpdateCurrencies([]);
    handleUpdateRisks([]);
    handleUpdateRoles([]);
    handleSearch("");
    handleSearchId("");
    handleSearchPublicId("");
    handleUpdateCategories([]);
    handleUpdateStatuses([]);
    handleApplyDate("", "");
    handleApply();
  };

  const handleApplyFilters = () => {
    handleApply();
  };

  return (
    <Filter
      handleClear={handleClearFilters}
      handleApply={handleApplyFilters}
      filterItems={[
        {
          type: FilterItemTypes.input,
          title: t("userEmail"),
          boxTitle: t("userEmail"),
          icon: gridIcon,
          inputValue: searchValue,
          setInputValue: handleSearch,
          inputType: "text",
        },
        {
          type: FilterItemTypes.input,
          title: t("userId"),
          boxTitle: t("userId"),
          icon: gridIcon,
          inputValue: searchId,
          setInputValue: handleSearchId,
          inputType: "text",
        },
        {
          type: FilterItemTypes.input,
          title: t("publicId"),
          boxTitle: t("publicId"),
          icon: gridIcon,
          inputValue: searchPublicId,
          setInputValue: handleSearchPublicId,
          inputPlaceholder: t("publicIdFilterPlaceholder"),
          inputType: "text",
        },
        {
          type: FilterItemTypes.multiselect,
          title: "GEO",
          boxTitle: t("filterGeos"),
          icon: gridIcon,
          itemsArray: geos,
          activeItems: selectedGeos,
          handleApply: handleApplyGeos,
          disabled: geos.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("currencies"),
          boxTitle: t("currencies"),
          icon: gridIcon,
          itemsArray: currencies,
          activeItems: selectedCurrencies,
          handleApply: handleApplyCurrencies,
          disabled: currencies.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("riskStatus"),
          boxTitle: t("riskStatus"),
          icon: gridIcon,
          itemsArray: risks,
          activeItems: selectedRisks,
          handleApply: handleApplyRisks,
          disabled: risks.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("category"),
          boxTitle: t("category"),
          icon: gridIcon,
          itemsArray: categories,
          activeItems: selectedCategories,
          handleApply: handleApplyCategories,
          disabled: categories.length === 0,
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("verificationStatus"),
          boxTitle: t("verificationStatus"),
          icon: gridIcon,
          itemsArray: statuses,
          activeItems: selectedStatuses,
          handleApply: handleApplyStatuses,
          disabled: statuses.length === 0,
        },
        {
          type: FilterItemTypes.datePicker,
          title: t("registrationDate"),
          boxTitle: t("registrationDate"),
          icon: gridIcon,
          handleApplyDate: handleApplyDate,
          onDeleteItem: handleResetDate,
          firstDateInitValue: firstDate,
          secondDateInitValue: secondDate,
          firstDatePlaceholder: t("from"),
          secondDatePlaceholder: t("to"),
          activeItems: [
            ...(firstDate
              ? [{ value: "from", label: `${t("from")}: ${firstDate}` }]
              : []),
            ...(secondDate
              ? [{ value: "to", label: `${t("to")}: ${secondDate}` }]
              : []),
          ],
        },
        {
          type: FilterItemTypes.multiselect,
          title: t("roles").replace(/^./, (letter) => letter.toUpperCase()),
          boxTitle: t("roles").replace(/^./, (letter) => letter.toUpperCase()),
          icon: gridIcon,
          itemsArray: roles,
          activeItems: selectedRoles,
          handleApply: handleApplyRoles,
          disabled: roles.length === 0,
        },
      ]}
    />
  );
};

export default PlayersFilter;
